// extracted by css-extract-rspack-plugin
export default {"collectionContainer":"_d9c76fba"};